'use client';

import { useEffect, useMemo } from 'react';
import { useSearchParams } from 'next/navigation';
import { telegramSourceEvent } from '@/_analytic/events/telegram-source-event';
import { UTM_PREFIX } from '@/_components/client-root-layout/_constants';
import { usePathname, useRouter } from '@/i18n/navigation';
import { getParamsCleanedUpFromUtm } from '../_utils/get-params-cleaned-up-from-utm';

export const useAnalytic = () => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const paramsObj = useMemo(
    () => Object.fromEntries(searchParams.entries()),
    [searchParams],
  );

  const isUtmLink = Object.keys(paramsObj).some((key) =>
    key.includes(UTM_PREFIX),
  );

  useEffect(() => {
    if (!isUtmLink) return;

    const url = searchParams.toString();

    telegramSourceEvent({
      url,
    });

    const cleanedParams = getParamsCleanedUpFromUtm(paramsObj);
    const cleanedQuery = new URLSearchParams(cleanedParams).toString();
    const newUrl = cleanedQuery ? `${pathname}?${cleanedQuery}` : pathname;

    router.replace(newUrl);
  }, [isUtmLink, paramsObj, pathname, router, searchParams]);
};
